// import { styled, StepConnector, stepConnectorClasses } from "@mui/material";

// export default styled(StepConnector)(({ theme }) => ({
//   [`&.${stepConnectorClasses.alternativeLabel}`]: {
//     top: 10,
//     left: "calc(-50% + 10.5px)",
//     right: "calc(50% + 10px)",
//   },
//   [`& .${stepConnectorClasses.line}`]: {
//     borderTopWidth: 3,
//     borderRadius: 1,
//   },
// }));
import { styled, StepConnector, stepConnectorClasses } from "@mui/material";

export default styled(StepConnector)(({ ml }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: ml?71:10,
    left: "calc(-50% + 10.5px)",
    right: "calc(50% + 10px)",
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderTopWidth: 3,
    borderRadius: 1,

  },
}));
